import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { restoreSession } from '../../../Component/axios_Interceptor/api';
import ContentState from '../../../Component/UI/ContentState';
import LayoutUser from '../../../Component/UI/Layout_user';
import TopBar from '../../../Component/UI/TopBar';
import LoginModal from '../Sign/Modal/LoginModal';
import NotificationSettings from './Component/NotificationSettings';
import BuyerFeatureIcon from '../../../Component/UI/BuyerFeatureIcon';

export default function NotificationSettingsPage() {
  const [session, setSession] = useState<'loading' | 'ready' | 'guest' | 'error'>('loading');
  const [loginVisible, setLoginVisible] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setSession('loading');
    restoreSession().then(token => {
      if (active) setSession(token ? 'ready' : 'guest');
    }).catch(() => { if (active) setSession('error'); });
    return () => { active = false; };
  }, [retry]);

  return <LayoutUser>
    <TopBar title="알림 설정" />
    <Page>
      {session === 'loading' ? <ContentState kind="loading" icon="account" title="알림 설정을 준비하고 있습니다." />
        : session === 'guest' ? <ContentState kind="locked" icon="account" title="로그인 후 알림을 설정할 수 있어요."
          description="팔로우한 스토어의 알림을 관리하세요." action={{ label: '로그인하기', onClick: () => setLoginVisible(true) }} />
        : session === 'error' ? <ContentState kind="error" icon="account" title="로그인 상태를 확인하지 못했습니다."
          action={{ label: '다시 시도', onClick: () => setRetry(value => value + 1) }} />
        : <>
          <Intro><span className="intro-icon"><BuyerFeatureIcon name="bell" size={24} /></span><div><h2>스토어별 알림</h2><p>팔로우한 스토어의 알림을 각각 설정할 수 있어요.</p></div></Intro>
          <NotificationSettings />
        </>}
    </Page>
    <LoginModal visible={loginVisible} handleModal={() => setLoginVisible(false)} returnTo="/my-notifications" />
  </LayoutUser>;
}

const Page = styled.main`padding:24px 20px calc(32px + env(safe-area-inset-bottom));color:var(--user-text);`;
const Intro = styled.div`
  display:flex;align-items:flex-start;gap:14px;margin-bottom:24px;
  .intro-icon{display:grid;place-items:center;flex-shrink:0;width:48px;height:48px;border-radius:14px;background:var(--user-accent-soft);color:var(--user-accent);}
  >div{min-width:0;}
  h2{margin:0;font:20px var(--font-Pretendard-SemiBold);line-height:1.4;}
  p{margin:8px 0 0;color:var(--user-text-muted);font-size:14px;line-height:1.6;word-break:keep-all;}
`;
